import { useMemo } from "react";

import { useAppShellBreadcrumb } from "@/shared/components/layout/useAppShellBreadcrumb";
import useTranslations from "@/shared/lang/useTranslations";

import { ComingSoonPage } from "../components/ComingSoonPage";

const TITLE = "Rutas y países";
const DESCRIPTION =
  "Configuración de rutas de pago y países disponibles. Gestiona los destinos y países donde opera la plataforma.";

export const RoutesCountriesPage = () => {
  const { t: tGlobal } = useTranslations("global");
  const breadcrumb = useMemo(
    () => [
      { label: tGlobal("sidebar_section_gestion") },
      { label: tGlobal("sidebar_menu_routes_countries"), to: "/app/routes-countries" },
    ],
    [tGlobal],
  );
  useAppShellBreadcrumb(breadcrumb);

  return <ComingSoonPage title={TITLE} description={DESCRIPTION} />;
};
